module.exports = __webpack_public_path__ + "static/the-hobbit-or-there-and-back-again-2a01f47dc2f1e608c2d69f752b2ff31e.jpg";